import gql from 'graphql-tag';

export const CLIENT_FEATURE_BETA_FRAGMENT = gql`
  fragment ClientFeatureBetaFragment on ClientFeatureBeta {
    id
    clientFeatureId
    clientFeatureName
    clientFeatureState
    title
    description
    sortOrder
    relations {
      relatedFeatureId
      relatedFeatureName
      relationType
    }
  }
`;

export const GET_CLIENT_FEATURE_BETAS_QUERY = gql`
  query GetClientFeatureBetasQuery {
    betas: getClientFeatureBetas {
      ...ClientFeatureBetaFragment
    }
  }
  ${CLIENT_FEATURE_BETA_FRAGMENT}
`;

export const SAVE_CLIENT_FEATURE_BETA_MUTATION = gql`
  mutation SaveClientFeatureBetaMutation($beta: SaveClientFeatureBetaInput!) {
    beta: saveClientFeatureBeta(beta: $beta) {
      ...ClientFeatureBetaFragment
    }
  }
  ${CLIENT_FEATURE_BETA_FRAGMENT}
`;

export const DELETE_CLIENT_FEATURE_BETA_MUTATION = gql`
  mutation DeleteClientFeatureBetaMutation($id: Int!) {
    deleted: deleteClientFeatureBeta(id: $id)
  }
`;

export const REORDER_CLIENT_FEATURE_BETAS_MUTATION = gql`
  mutation ReorderClientFeatureBetasMutation($orderedIds: [Int!]!) {
    reordered: reorderClientFeatureBetas(orderedIds: $orderedIds)
  }
`;
